import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import { Button } from '@common/components/Button';

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  border-top: 1px solid ${({ theme }) => theme.defaultColors.lightGrey};

  ${media.lg`
    border-top: unset;
  `}
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  ${media.lg`
    margin-top: 25px;
    flex-direction: row;
  `}
`;

export const Row = styled.div`
  padding: 10px 0;
`;

export const SubmitButton = styled(Button)`
  width: 100%;
  margin: 30px 0 23px 0;

  ${media.lg`
    margin-top: 0;
    margin-left: 20px;
    width: auto;
  `}
`;

export const OptionsSelectWrapper = styled.div`
  margin-bottom: 10px;
  ${media.lg`
    max-width: 380px;
    margin-bottom: unset;
  `}
`;

export const ComingSoonButton = styled.div`
  border-radius: 50px;
  width: fit-content;
  padding: 10px 30px;
  font-weight: 600;
  background-color: ${({ theme }) => theme.defaultColors.lightGrey}55;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
